import * as React from 'react';

import { cn } from '../../lib/utils';

const TypographyH1 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h1
    ref={ref}
    className={cn('scroll-m-20 text-display-2xl font-regular', className)}
    {...props}
  />
));
TypographyH1.displayName = 'TypographyH1';

export { TypographyH1 };
